/** 'YYYY-MM-DD' in the user's zone. A calendar date, never an instant. */
export type LocalDate = string

const pad = (n: number): string => String(n).padStart(2, '0')

/** Local calendar date from the local getters; toISOString would be the UTC date. */
export function localToday(now: Date = new Date()): LocalDate {
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
}

function parts(d: LocalDate): [number, number, number] {
  const [y = 0, m = 0, day = 0] = d.split('-').map(Number)
  return [y, m, day]
}

/** `d` shifted by `days` calendar days. UTC arithmetic on the parts: no zone or DST can move it. */
export function addDays(d: LocalDate, days: number): LocalDate {
  const [y, m, day] = parts(d)
  const t = new Date(Date.UTC(y, m - 1, day + days))
  return `${t.getUTCFullYear()}-${pad(t.getUTCMonth() + 1)}-${pad(t.getUTCDate())}`
}
